import { createApp, h } from 'vue/dist/vue.esm-bundler';
import DersligToast from '../components/toast/DersligToast.vue';

class ToastService {
  constructor() {
    this.toasts = [];
    this.toastContainers = {};
    this.maxToasts = 10;
    
    this.clearAllContainers();
  }

  clearAllContainers() {
    const oldContainers = document.querySelectorAll('[id^="derslig-toast-container-"]');
    oldContainers.forEach(container => {
      container.remove();
    });
    this.toastContainers = {};
  }

  // Vue entegrasyonu
  install(app) {
    app.config.globalProperties.$toast = this;
    window.showToast = this.show.bind(this);
    return this;
  }

  getContainer(position) {
    if (!this.toastContainers[position]) {
      const container = document.createElement('div');
      container.id = `derslig-toast-container-${position}`;
      
      container.style.position = 'fixed';
      container.style.zIndex = '9999';
      
      // Konteyner genişliğini optimize et
      if (position.includes('center')) {
        container.style.width = 'auto';
        container.style.maxWidth = '350px';
      } else {
        container.style.width = 'auto';
        container.style.maxWidth = 'min(350px, 80vw)';
      }
      
      switch(position) {
        case 'top-left':
          container.style.top = '20px';
          container.style.left = '20px';
          break;
        case 'top-center':
          container.style.top = '20px';
          container.style.left = '50%';
          container.style.transform = 'translateX(-50%)';
          break;
        case 'top-right':
          container.style.top = '20px';
          container.style.right = '20px';
          container.style.left = 'auto';
          break;
        case 'bottom-left':
          container.style.bottom = '20px';
          container.style.left = '20px';
          break;
        case 'bottom-center':
          container.style.bottom = '20px';
          container.style.left = '50%';
          container.style.transform = 'translateX(-50%)';
          break;
        case 'bottom-right':
          container.style.bottom = '20px';
          container.style.right = '20px';
          container.style.left = 'auto';
          break;
        case 'mid-center':
          container.style.top = '50%';
          container.style.left = '50%';
          container.style.transform = 'translate(-50%, -50%)';
          break;
      }
      
      document.body.appendChild(container);
      this.toastContainers[position] = container;
    }
    return this.toastContainers[position];
  }

  // Toast göster
  show(options) {
    if (typeof options === 'string') {
      options = { text: options };
    }

    if (arguments.length > 1 && typeof arguments[1] === 'string') {
      options.type = arguments[1];
    }

    const defaultOptions = {
      heading: null,
      text: '',
      type: 'info',
      duration: 5000,
      position: 'top-center',
      allowClose: true,
      showIcon: true,
      playSound: false,
      soundSrc: "/assets/sounds/toast_alert.mp3",
      autoHeading: true,
      animation: 'slide',
      responsive: true,
      showProgress: false
    };

    const toastOptions = { ...defaultOptions, ...options };

    if (this.toasts.length > this.maxToasts) {
      const oldToast = this.toasts.shift();
      if (oldToast && oldToast.$el && oldToast.$el.parentNode) {
        oldToast.$el.parentNode.removeChild(oldToast.$el);
      }
    }

    const container = this.getContainer(toastOptions.position);
    
    const toastDiv = document.createElement('div');
    toastDiv.style.marginBottom = '10px';
    toastDiv.style.width = '100%';
    
    if (toastOptions.position.includes('right')) {
      toastDiv.style.marginLeft = 'auto';
    } else if (toastOptions.position.includes('left')) {
      toastDiv.style.marginRight = 'auto';
    }
    
    container.appendChild(toastDiv);

    const self = this;

    const app = createApp({
      render() {
        return h(DersligToast, {
          ...toastOptions,
          onClose: () => {
            app.unmount();
            if (toastDiv.parentNode) {
              toastDiv.parentNode.removeChild(toastDiv);
            }
            if (self.toasts) {
              self.toasts = self.toasts.filter(t => t !== app);
            }
          }
        });
      }
    });

    app.mount(toastDiv);
    this.toasts.push(app);

    return app;
  }

  // jQuery uyumluluğu için
  jQueryCompatibility() {
    if (window.$ && !$.toast) {
      $.toast = (options) => {
        const mappedOptions = {
          heading: options.heading || null,
          text: options.text || '',
          type: this.mapJqueryType(options.icon) || 'info',
          duration: options.hideAfter || 5000,
          position: options.position || 'top-center',
          allowClose: options.allowToastClose !== false,
          showIcon: true,
          playSound: false,
          animation: options.showHideTransition || 'slide',
          showProgress: false
        };

        if (options.bgColor) {
          mappedOptions.bgColor = options.bgColor;
        }
        
        if (options.textColor) {
          mappedOptions.textColor = options.textColor;
        }

        return this.show(mappedOptions);
      };
    }
  }

  mapJqueryType(icon) {
    const map = {
      'success': 'success',
      'error': 'error',
      'warning': 'warning',
      'info': 'info',
      'danger': 'danger'
    };
    return map[icon] || 'info';
  }
}

const toastService = new ToastService();

document.addEventListener('DOMContentLoaded', () => {
  toastService.jQueryCompatibility();
});

window.showToast = toastService.show.bind(toastService);

export default toastService; 